<template>
    <div class="pp-buy-box" :class="{ 'is-sticky': isSticky }">

        <template v-if="isOwned">
            <div class="pp-buy-owned-badge">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"/>
                </svg>
                You already own this
            </div>
            <a
                class="pp-buy-btn pp-buy-btn--owned"
                :href="toolkitUrl || (accURL + '/dashboard')"
            >Open toolkit →</a>

            <div class="pp-buy-owned-hint">
                Continue where you left off — your progress is saved.
            </div>
        </template>

        <template v-else>

            <div class="pp-buy-top">
                <div class="pp-buy-urgency" v-if="buyBox.urgency_text">
                    <div class="pp-buy-urgency-dot"></div>
                    <span v-html="buyBox.urgency_text"></span>
                </div>
                <div class="pp-buy-rating" v-if="buyBox.rating">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="#FBBF24" viewBox="0 0 16 16">
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"></path>
                    </svg>
                    {{ buyBox.rating }}
                    <span v-if="buyBox.rating_count">({{ buyBox.rating_count }})</span>
                </div>
            </div>

            <div class="pp-buy-price-row">
                <div class="pp-buy-price">{{ formatMoney(product.sale_price) }}</div>
                <div class="pp-buy-price-old" v-if="hasDiscount">{{ formatMoney(product.price) }}</div>
                <div class="pp-buy-save" v-if="savePercent > 0">SAVE {{ savePercent }}%</div>
            </div>

            <div class="pp-buy-details" v-if="buyBox.details" v-html="buyBox.details"></div>

            <!-- CTA -->
            <button
                class="pp-buy-btn"
                :class="{ 'pp-buy-btn--loading' : this.isLoading }"
                :disabled="isLoading"
                @click="handleBuy"
            >
                <template v-if="isLoading">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" width="1em" height="1em">
                        <path fill="#FFE8B6" d="M21 18c0-2.001 3.246-3.369 5-6 2-3 2-10 2-10H8s0 7 2 10c1.754 2.631 5 3.999 5 6s-3.246 3.369-5 6c-2 3-2 10-2 10h20s0-7-2-10c-1.754-2.631-5-3.999-5-6z"/><path fill="#FFAC33" d="M18 2h-8s0 4 1 7c1.304 3.912 6 4.999 6 9s0 13 1 13 1-9 1-13 4.697-5.088 6-9c1-3 1-7 1-7h-8z"/><path fill="#3B88C3" d="M30 34c0 1.104-.896 2-2 2H8c-1.104 0-2-.896-2-2s.896-2 2-2h20c1.104 0 2 .896 2 2zm0-32c0 1.104-.896 2-2 2H8c-1.104 0-2-.896-2-2s.896-2 2-2h20c1.104 0 2 .896 2 2z"/>
                    </svg>
                    Loading…
                </template>

                <template v-else>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g class="lock" id="lock">
                        <path class="shackle" d="M8 11L8 7C8 5.939 8.421 4.922 9.172 4.172C9.922 3.421 10.939 3 12 3C13.061 3 14.078 3.421 14.828 4.172C15.579 4.922 16 5.939 16 7L16 11" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M17 11H7C5.89543 11 5 11.8954 5 13V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V13C19 11.8954 18.1046 11 17 11Z" fill="currentColor" fill-opacity="0.1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 17.5C12.8284 17.5 13.5 16.8284 13.5 16C13.5 15.1716 12.8284 14.5 12 14.5C11.1716 14.5 10.5 15.1716 10.5 16C10.5 16.8284 11.1716 17.5 12 17.5Z" fill="currentColor" fill-opacity="0.4"/>
                        </g>
                    </svg>
                    <span>Get Instant Access</span>
                </template>
            </button>

            <a
                class="pp-gets-btn"
                :href="baseURL + '/pricing?source=product'"
                v-if="!isAuth"
                target="_blank"
                @click="onTryPass"
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" width="1em" height="1em"><path fill="#FFAC33" d="M34.347 16.893l-8.899-3.294-3.323-10.891c-.128-.42-.517-.708-.956-.708-.439 0-.828.288-.956.708l-3.322 10.891-8.9 3.294c-.393.146-.653.519-.653.938 0 .418.26.793.653.938l8.895 3.293 3.324 11.223c.126.424.516.715.959.715.442 0 .833-.291.959-.716l3.324-11.223 8.896-3.293c.391-.144.652-.518.652-.937 0-.418-.261-.792-.653-.938z"/><path fill="#FFCC4D" d="M14.347 27.894l-2.314-.856-.9-3.3c-.118-.436-.513-.738-.964-.738-.451 0-.846.302-.965.737l-.9 3.3-2.313.856c-.393.145-.653.52-.653.938 0 .418.26.793.653.938l2.301.853.907 3.622c.112.444.511.756.97.756.459 0 .858-.312.97-.757l.907-3.622 2.301-.853c.393-.144.653-.519.653-.937 0-.418-.26-.793-.653-.937zM10.009 6.231l-2.364-.875-.876-2.365c-.145-.393-.519-.653-.938-.653-.418 0-.792.26-.938.653l-.875 2.365-2.365.875c-.393.146-.653.52-.653.938 0 .418.26.793.653.938l2.365.875.875 2.365c.146.393.52.653.938.653.418 0 .792-.26.938-.653l.875-2.365 2.365-.875c.393-.146.653-.52.653-.938 0-.418-.26-.792-.653-.938z"/></svg>
                <span>Try Free with Ecomzy Pass</span>
            </a>

            <div class="pp-buy-trust" v-if="buyBox.trust_items && buyBox.trust_items.length">
                <div class="pp-buy-trust-item" v-for="(item, i) in buyBox.trust_items" :key="i" v-html="item"></div>
            </div>

            <div class="pp-buy-social" v-if="buyBox.social_proof">
                <strong>{{ buyBox.social_proof.count }}</strong>
                <span v-html="buyBox.social_proof.label"></span>
            </div>

        </template>
    </div>
</template>

<script>
import { track, trackEcommerce, gtmItem, productParams, GTM_EVENTS } from '../../js/utils/gtm';

export default {
    name: 'BuyBox',

    props: {
        product: { type: Object, required: true },
        buyBox:  { type: Object, required: true },
        owned:   { type: Boolean, default: false },
        toolkitUrl: { type: String, default: '' },
    },

    data() {
        return {
            isLoading : false,
            isOwned   : this.owned,
            isAuth    : !! window.productData?.is_auth,
            isSticky  : false,
            baseURL   : window.baseURL || '',
            accURL    : window.accURL || '',
        };
    },

    computed: {

        hasDiscount() {
            return this.product.price > 0 && this.product.sale_price < this.product.price;
        },

        savePercent() {
            if ( !this.hasDiscount ) return 0;
            return Math.round( ( 1 - this.product.sale_price / this.product.price ) * 100 );
        },

    },

    mounted() {
        window.addEventListener( 'scroll', this.onScroll, { passive: true } );
        this.onScroll();

        window.addEventListener( 'pageshow', this.resetLoader );

        this.trackProductView();
    },

    beforeUnmount() {
        window.removeEventListener( 'scroll', this.onScroll );
        window.removeEventListener( 'pageshow', this.resetLoader );
    },

    methods: {

        resetLoader( event ) {
            // Сбрасываем loader при возврате через browser back (bfcache)
            if( event.persisted )
                this.isLoading = false;
        },

        onScroll() {
            this.isSticky = window.scrollY > 80;
        },

        formatMoney( cents ) {
            if ( !cents && cents !== 0 ) return '';
            const d = cents / 100;
            return '$' + ( Number.isInteger( d ) ? d : d.toFixed( 2 ) );
        },

        // PP: view_item + product_cta_viewed (product_type=instant).
        trackProductView() {

            const priceUsd = +( ( this.product.sale_price || 0 ) / 100 ).toFixed( 2 );

            trackEcommerce( GTM_EVENTS.VIEW_ITEM, {
                currency : 'USD',
                value    : priceUsd,
                items    : [ gtmItem( {
                    id       : this.product.slug,
                    name     : this.product.name,
                    category : 'product',
                    price    : priceUsd,
                } ) ],
            }, productParams( {   // F-04 + F-03: product_id строкой
                id   : this.product.id,
                type : 'instant',
            } ) );

            track( GTM_EVENTS.PRODUCT_CTA_VIEWED, productParams( {
                id         : this.product.id,
                type       : 'instant',
                card_state : this.isOwned ? 'owned' : ( this.isAuth ? 'logged' : 'guest' ),
            } ) );
        },

        // F-22: клик "Try Free with Ecomzy Pass" на instant-карточке.
        // target=_blank не блокирует навигацию - хит успевает уйти.
        onTryPass() {
            track( GTM_EVENTS.PASS_PROMO_CLICKED, productParams( {
                id     : this.product.id,   // F-03: product_id строкой
                source : 'product_page',
            } ) );
        },

        async handleBuy() {

            if ( this.isLoading || this.isOwned ) return;
            this.isLoading = true;

            try {

                // Авторизован - проверяем не куплено ли уже
                if ( window.productData?.is_auth ) {
                    const owned = await this.checkOwned();
                    if ( owned ) {
                        this.isOwned   = true;
                        this.isLoading = false;
                        return;
                    }
                }

                // Сохраняем product в sessionStorage → идём на checkout.
                // begin_checkout шлётся на открытии страницы /checkout (Checkout.vue).
                sessionStorage.setItem( 'checkout_product_id', String( this.product.id ) );
                sessionStorage.setItem( 'checkout_product_slug', this.product.slug );

                window.location.href = this.baseURL + '/checkout/' + this.product.slug;

            } catch ( e ) {
                console.error( 'BuyBox error:', e );
                this.isLoading = false;
            }
        },

        async checkOwned() {
            try {
                const response = await this.$http.post( '/products/check-owned', {
                    product_id: this.product.id,
                } );

                const { status, data } = response?.data || {};
                return status === 'success' && !!data?.owned;

            } catch {
                return false;
            }
        },
    },
};
</script>